/* Suggestions in the cart and the cart drawer.

   Three things the theme's own element gets wrong here.

   It waits for an IntersectionObserver before fetching, and the drawer sits
   at left: 100vw with visibility: hidden until someone opens it, so that
   never fires.

   It is rendered once with a product id baked into its url, so after an item
   is added the suggestions are still the ones for whatever was in the cart
   before. This reads the cart at the moment it asks, so the suggestions
   follow what is actually in there, and the section it fetches leaves out
   anything already added.

   And it gives up when Search & Discovery has nothing set for a product.
   This falls back to Shopify's own recommendations, so the block is only
   empty when there is really nothing to show. */
(function () {
  var SELECTOR = '[data-bakkeleg-upsell]';
  var CONTENT = '[data-bakkeleg-upsell-content]';
  var base = (window.theme && window.theme.routes && window.theme.routes.product_recommendations_url)
    || '/recommendations/products';

  function url(el, seed, intent) {
    return base
      + '?section_id=' + encodeURIComponent(el.getAttribute('data-section'))
      + '&product_id=' + encodeURIComponent(seed)
      + '&limit=' + encodeURIComponent(el.getAttribute('data-limit') || 10)
      + '&intent=' + encodeURIComponent(intent)
      + (el.getAttribute('data-stamp') ? '&v=' + encodeURIComponent(el.getAttribute('data-stamp')) : '');
  }

  /* The section filters by cart too, but the recommendations endpoint is
     cached and its Liquid does not always see the live cart, so anything
     already in the basket is taken out here as well. */
  function dropWhatIsInTheCart(el, handles) {
    var cards = el.querySelectorAll('[data-url], a[href*="/products/"]');
    for (var i = 0; i < cards.length; i++) {
      var href = cards[i].getAttribute('data-url') || cards[i].getAttribute('href') || '';
      var handle = href.split('/products/')[1];
      if (!handle) continue;
      handle = handle.split('?')[0].split('#')[0].split('/')[0];
      if (handles.indexOf(handle) === -1) continue;

      var card = cards[i].closest('.grid-item, .cart__upsell__item, .product-upsell, quick-add-product');
      if (card && card.parentNode) card.parentNode.removeChild(card);
    }
  }

  /* The drawer and the cart page are two different sections, and only the
     drawer's is built around a track of its own. */
  function isDrawer(el) {
    return el.getAttribute('data-section') === 'api-cart-upsell';
  }

  /* Shopify caches this endpoint, so a response rendered before the section
     had a track can still come back. Without that wrapper the cards are
     loose children of a plain div and six of them flow across in a line.
     One is built here if it is missing, so an old cached response lays out
     the same as a fresh one.

     Only for the drawer. The cart page section brings the shop's own slider,
     which has no track by that name, so this used to rebuild the whole row
     as a single drawer card: eight products squeezed into half the width of
     the page. */
  function ensureTrack(el) {
    if (!isDrawer(el)) return;
    if (el.querySelector('.cart__upsell__track')) return;

    var slider = document.createElement('div');
    slider.className = 'cart-recs cart-recs--drawer bakkeleg-slider';
    slider.setAttribute('data-bakkeleg-slider', '');

    var track = document.createElement('div');
    track.className = 'grid grid--slider cart__upsell__track';
    track.setAttribute('data-bakkeleg-track', '');

    var node = el.firstChild;
    while (node) {
      var next = node.nextSibling;
      var isTitle = node.nodeType === 1 && node.classList.contains('cart__upsell__title');
      if (!isTitle) {
        if (node.nodeType === 1 && !node.hasAttribute('data-grid-item')) {
          var cell = document.createElement('div');
          cell.className = 'grid-item';
          cell.setAttribute('data-grid-item', '');
          cell.appendChild(node);
          track.appendChild(cell);
        } else {
          track.appendChild(node);
        }
      }
      node = next;
    }

    slider.appendChild(track);
    el.appendChild(slider);
  }

  var MINIMUM = 4;

  var TRACK = '[data-bakkeleg-track], .cart__upsell__track, .grid--slider';

  function cards(el) {
    var track = el.querySelector(TRACK);
    return track ? track.children.length : 0;
  }

  /* A shop sets complementary products for a handful of items, not for all of
     them, so asking only for those often returns two. Rather than show a
     slider with nothing to slide, the rest of the row is filled from
     Shopify's own recommendations. */
  function topUp(el, seed, intents, handles) {
    if (cards(el) >= MINIMUM) return;
    if (intents.indexOf('related') === -1) return;

    fetch(url(el, seed, 'related'))
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html;

        var track = el.querySelector(TRACK);
        var extra = holder.querySelector(TRACK);
        if (!track || !extra) return;

        var have = {};
        var links = track.querySelectorAll('[data-url]');
        for (var i = 0; i < links.length; i++) have[links[i].getAttribute('data-url')] = true;

        var candidates = Array.prototype.slice.call(extra.children);
        for (var j = 0; j < candidates.length && track.children.length < MINIMUM; j++) {
          var card = candidates[j];
          var link = card.querySelector('[data-url]') || card;
          var key = link.getAttribute ? link.getAttribute('data-url') : null;
          if (key && have[key]) continue;
          track.appendChild(card);
          if (key) have[key] = true;
        }

        dropWhatIsInTheCart(el, handles);
        el.dispatchEvent(new CustomEvent('bakkeleg:upsell:loaded', {bubbles: true}));
      })
      .catch(function () {});
  }

  function inject(el, seed, intents, handles) {
    var intent = intents.shift();
    if (!intent) {
      el.innerHTML = '';
      return;
    }

    fetch(url(el, seed, intent))
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var found = holder.querySelector(CONTENT);

        /* Nothing to show means no product cards, not an empty element. A
           section can return a style tag and no products, and measuring the
           markup instead of counting the cards left the page with a band of
           white where the suggestions should have been, and no second ask. */
        if (!found || !found.querySelector('[data-grid-item]')) {
          inject(el, seed, intents, handles);
          return;
        }

        el.innerHTML = found.innerHTML;
        dropWhatIsInTheCart(el, handles);
        ensureTrack(el);
        topUp(el, seed, intents, handles);

        /* Everything suggested was already in the cart, so the cards have
           just been taken out again. */
        if (!el.querySelector('[data-grid-item]')) {
          el.innerHTML = '';
          inject(el, seed, intents, handles);
          return;
        }

        el.dispatchEvent(new CustomEvent('bakkeleg:upsell:loaded', {bubbles: true}));
      })
      .catch(function () { inject(el, seed, intents, handles); });
  }

  var pending = null;

  function load() {
    var items = document.querySelectorAll(SELECTOR);
    if (!items.length) return;

    if (pending) return;
    pending = fetch('/cart.js', {headers: {Accept: 'application/json'}})
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        pending = null;
        if (!cart.items || !cart.items.length) {
          for (var i = 0; i < items.length; i++) items[i].innerHTML = '';
          return;
        }

        // the last thing added is the one a suggestion should follow, unless
        // that is the gift wrapping line
        var wrap = document.querySelector('[data-gift-wrap]');
        var wrapId = wrap ? Number(wrap.dataset.productId) : 0;
        var products = cart.items.filter(function (item) { return item.product_id !== wrapId; });
        if (!products.length) return;
        var seed = products[products.length - 1].product_id;
        var handles = cart.items.map(function (item) { return item.handle; });
        var stamp = seed + ':' + cart.item_count;

        for (var j = 0; j < items.length; j++) {
          var el = items[j];
          if (el.dataset.upsellStamp === stamp && el.innerHTML.trim().length) continue;
          el.dataset.upsellStamp = stamp;
          var intents = [el.getAttribute('data-intent') || 'complementary'];
          if (intents[0] !== 'related') intents.push('related');
          inject(el, seed, intents, handles);
        }
      })
      .catch(function () { pending = null; });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load);
  } else {
    load();
  }

  ['theme:cart:change', 'theme:cart:update', 'theme:cart:refresh', 'theme:cart:add', 'theme:cart:toggle']
    .forEach(function (name) {
      document.addEventListener(name, function () {
        window.setTimeout(load, 120);
      });
    });

  document.addEventListener('shopify:section:load', function () { load(); });
})();
